<template>
  <div class="">
    <div class="row">
      <div class="col-md-7">
        <Card collapse :Name="'1'" v-if="Refresh">
          <template v-slot:header>
            <h4 class="d-inline">افزودن مخاطب</h4>
            <!-- <hr /> -->
          </template>
          <template v-slot:content>
            <div class="row mt-2">
              <div class="col-md-4 col-12">
                <small id="LblName">نام </small>
                <input dir="ltr" type="text" class="form-control text-right" id="Name" v-model="Contact.Name" />
              </div>
              <div class="col-md-4 col-12">
                <small id="LblFamily">نام خانوادگی </small>
                <input dir="ltr" type="text" class="form-control text-right" id="Family" v-model="Contact.Family" />
              </div>
              <div class="col-md-4 col-12">
                <small id="LblNikName">نام مستعار</small>
                <input dir="ltr" type="text" class="form-control text-right" id="NikName" v-model="Contact.NikName" />
              </div>
              <div class="col-md-12 col-12">
                <small id="LblDescription">توضیحات</small>
                <input dir="ltr" type="text" class="form-control text-right" id="Description" v-model="Contact.Description" />
              </div>
              <div class="col-md-6 col-12">
                <small id="LblEmail">ایمیل</small>
                <input dir="ltr" type="text" class="form-control" id="Email" v-model="Contact.Email" />
              </div>
              <div class="col-md-6 col-12">
                <small id="LblToll">دسته بندی</small>
                <SearchableCombo
                  v-if="$store.state.renderComponentCombo"
                  :edit="false"
                  :noIcone="false"
                  :grp="27"
                  :code="null"
                  @ResultCombo="GetResultGrp27"
                  :rownumintable="3"
                  :defaultvalue="Def27"
                  :action="'TblCrmCombo/GetComboById'"
                  :ClassProps="''"
                  :method="'POST'"
                  :idinput="'Grp27Id'"
                  :keyItem="'Grp27Id'"
                >
                </SearchableCombo>
              </div>
              <div class="col-md-12 col-12"><hr /></div>

               <div class="col-md-6 col-12 " v-for="(item,index) in TypeNumber" :key="item.id">
                <div class="row">
                  <div class="col-md-9 col-12 pl-0">
                    <small :id="'LblLable'+item.id">{{ item.name }} </small>
                    <input dir="ltr" type="text" @keypress="$ValidNumber($event, 11)" class="form-control mt-1 Inputs" v-model="Contact.Mobile[index].number" :id="'Mobile'+item.id" />
                  </div>
                  <div class="col-md-3 mt-2 col-12">
                    <i class="far fa-check-circle fa-2x mt-4" @click="SetIsMain(item)"></i>
                  </div>
                </div>
              </div> 

              <div class="col-md-12 col-12"><hr /></div>

              <div class="col-md-6 col-12 mt-2 d-none">
                <small>به عنوان شماره پیش فرض</small>
                <SearchableCombo
                  v-if="$store.state.renderComponentCombo"
                  :edit="false"
                  :noIcone="false"
                  :grp="28"
                  :code="null"
                  @ResultCombo="GetResultGrp28"
                  :rownumintable="3"
                  :defaultvalue="Def28"
                  :action="'TblCrmCombo/GetComboById'"
                  :ClassProps="''"
                  :method="'POST'"
                  :idinput="'Grp28Id'"
                  :keyItem="'Grp28Id'"
                >
                </SearchableCombo>
              </div>
              <div class="col-md-6 col-12 mt-2">
                <button class="btn btn-success mr-3 mt-4" v-if="!Error && !EditMode" @click="SetContact"><i class="fal fa-user-plus ml-3"></i>ثبت مخاطب جدید</button>
                <button class="btn btn-warning mr-3 mt-4" v-if="!Error && EditMode" @click="SetContact">ویرایش  مخاطب </button>
                <button class="btn btn-outline-warning mr-3 mt-4" v-if="EditMode" @click="CancelEditing">  انصراف </button>
              </div>
            </div>
           
          </template>
        </Card>
        <div class="row">
          <div class="col-md-6 col-12">
            <Card :Name="'2'">
              <template v-slot:header>
                <h4 class="d-inline">دسته بندی ها</h4>
              </template>
              <template v-slot:content>
                <div class="row">
                  <div class="col-12 mb-3 mt-2">
                    <a
                      v-if="AddModeGroups == 0"
                      class="d-inline float-right mx-2 mt-1"
                      href="javascript:;"
                      @click="
                        AddModeGroups = 1
                        GroupsName = ''
                      "
                      title="افزودن دسته بندی جدید"
                    >
                      <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
                    </a>
                    <a v-if="AddModeGroups != 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddModeGroups = 0" title="لغو افزودن">
                      <h4><i class="fas fa-times text-danger"></i></h4>
                    </a>
                  </div>
                  <div class="col-12 text-center required" v-if="AddModeGroups != 0">
                    <div class="text-right">
                      <small>نام دسته بندی</small>
                      <input type="text" class="form-control" v-model="GroupsName" />
                    </div>
                    <button v-if="AddModeGroups == 1" class="btn btn-success mt-2" @click="SetData(27, GroupsName)"><i class="fa fa-plus ml-2"></i>ثبت دسته بندی جدید</button>
                    <button v-if="AddModeGroups == -1" class="btn btn-warning mt-2" @click="EditData(IdIsEditGroups, GroupsName)"><i class="fa fa-pen ml-2"></i>ویرایش دسته بندی</button>
                  </div>
                  <div class="col-12" v-if="AddModeGroups == 0 && Refresh">
                    <div class="bg-groups p-2" v-for="item in Groups" :key="item.id">
                      <span>{{ item.name }}</span>
                      <span class="float-left ml-1" v-if="item.id != 1037831"
                        ><i
                          class="fad fa-pen hover-warning Pointer"
                          @click="
                            Edit(item, 27)
                            IdIsEditGroups = item.id
                          "
                        ></i
                      ></span>
                      <span class="float-left ml-3" v-if="item.id != 1037831"><i class="fad fa-trash hover-danger Pointer" @click="Delete(item.id)"></i></span>
                    </div>
                  </div>
                </div>
              </template>
            </Card>
          </div>
          <div class="col-md-6 col-12">
            <Card>
              <template v-slot:header>
                <h4 class="d-inline">انواع شماره</h4>
              </template>
              <template v-slot:content>
                <div class="row">
                  <div class="col-12 mb-3 mt-2">
                    <a
                      v-if="AddModeTypeNumber == 0"
                      class="d-inline float-right mx-2 mt-1"
                      href="javascript:;"
                      @click="
                        AddModeTypeNumber = 1
                        TypeNumberName = ''
                      "
                      title="افزودن نوع شماره جدید"
                    >
                      <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
                    </a>
                    <a v-if="AddModeTypeNumber != 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddModeTypeNumber = 0" title="لغو افزودن">
                      <h4><i class="fas fa-times text-danger"></i></h4>
                    </a>
                  </div>
                  <div class="col-12 text-center" v-if="AddModeTypeNumber != 0">
                    <div class="text-right">
                      <small>نام نوع</small>
                      <input type="text" class="form-control" v-model="TypeNumberName" />
                    </div>
                    <button v-if="AddModeTypeNumber == 1" class="btn btn-success mt-2" @click="SetData(28, TypeNumberName)"><i class="fa fa-plus ml-2"></i>ثبت نوع شماره جدید</button>
                    <button v-if="AddModeTypeNumber == -1" class="btn btn-warning mt-2" @click="EditData(IdIsEditTypeNumber, TypeNumberName)"><i class="fa fa-pen ml-2"></i>ویرایش نوع شماره</button>
                  </div>
                  <div class="col-12" v-if="AddModeTypeNumber == 0 && Refresh">
                    <div class="bg-groups p-2" v-for="item in TypeNumber" :key="item.id">
                      <span>{{ item.name }}</span>
                      <span class="float-left ml-1" v-if="item.id != 1037828"
                        ><i
                          class="fad fa-pen hover-warning Pointer"
                          @click="
                            Edit(item, 28)
                            IdIsEditTypeNumber = item.id
                          "
                        ></i
                      ></span>
                      <span class="float-left ml-3" v-if="item.id != 1037828"><i class="fad fa-trash hover-danger Pointer" @click="Delete(item.id)"></i></span>
                    </div>
                  </div>
                </div>
              </template>
            </Card>
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <Card>
          <template v-slot:header>
            <input type="text" @input="Search($event)" class="form-control" placeholder="جستجو مخاطب" />
          </template>
        </Card>
        <div class="box p-2" v-if="ListContact.length>0 ">
          <div class="Contact p-2 Pointer mt-2" dir="ltr"  v-for="item in ListContact" :key="item.Id">
            <div class="row">
              <div class="col-xl-10 col-12">
                <div class="row" dir="rtl">
                  <div class="col-xl-6 col-12 text-right">
                    <h5 class="mt-2" :title="item.Description">{{ item.Name }} {{ item.Family }}</h5>
                  </div>
                  <div class="col-xl-6 col-12 text-center">
                    <b-dropdown size="md" variant="link" class="d-inline float-left" toggle-class="text-decoration-none" no-caret>
                        <template #button-content><h4><i class="fal fa-ellipsis-v-alt text-secondary"></i></h4></template>
                        <b-dropdown-item @click="Edit(item)">ویرایش</b-dropdown-item>
                        <!-- <b-dropdown-item href="#">ارسال پیامک</b-dropdown-item> -->
                        <b-dropdown-item @click="Remove(item)">حذف</b-dropdown-item>
                    </b-dropdown>
                    <h5 class="mt-2" v-for="n in item.NUM" :key="n.Id">
                      <span v-if="n.IsMain" title="برای تماس کلیک کنید" @click="CallQuestion(item,n.Number,n.numberType)">{{ n.Number }}</span>
                    </h5>
                  </div>
                  
                  <div class="col-12">
                    <span class="badge badge-warning font-weight-normal ml-1 ">{{ item.contactGroup }}</span>
                    <h5 class="d-inline"> - </h5>
                    <span class="badge border border-warning font-weight-normal ml-1 text-light" title="برای تماس کلیک کنید" v-for="nt in item.NUM" :key="nt.Id"><span @click="CallQuestion(item,nt.Number,nt.numberType)">{{ nt.numberType }} </span></span>
                    <!-- <h5 class="d-inline"> - </h5> -->
                    <!-- <span v-if="item.IsEditing" class="badge badge-danger font-weight-normal ml-1 ">درحال ویرایش</span> -->
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-12 text-center d-lg-none d-md-none d-sm-none d-none d-xl-block">
                <div class="Icon" :title="item.NikName+' : نام مستعار '"><div style="font-size: 18px">{{ item.Mokhafaf }}</div></div>
              </div>
            </div>
          </div>
        </div>
        <div class="box p-2 text-center" v-if="ListContact.length==0">
          <h5 class="mt-3">اطلاعاتی از شماره تلفن ها یافت نشد</h5><small>( از بخش افزودن مخاطب میتوانید مخاطب جدیدی اضافه کنید )</small>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
  data() {
    return {
      Contact: {Name:"",Family:"",NikName:"",Description:"",Email:"", Mobile: [] },
      AddModeGroups: 0,
      AddModeTypeNumber: 0,
      Groups: [],
      TypeNumber: [],
      GroupsName: '',
      TypeNumberName: '',
      Refresh: true,
      IdIsEditTypeNumber: 0,
      IdIsEditGroups: 0,
      ListContact:[],
      ListContactCopy:[],
      Def27:null,
      Def28:null,
      Error:true,
      voip:"",
      EditMode:false,
      Render:true
    }
  },
  components: { Card, SearchableCombo },
  created() {
    this.GetGroups()
    this.GetTypeNumber()
    this.GetAllData();
  },
  methods: {
    GetGroups() {
      var formData = new FormData()
      formData.append('grp', 27)
      var DataAxios = { Method: 'POST', Action: 'PhoneBook/GetGrp27And28', ArryfildValue: null }
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((res) => {
        this.Groups = res.data
      })
    },
    GetTypeNumber() {
      var formData = new FormData()
      formData.append('grp', 28)
      var DataAxios = { Method: 'POST', Action: 'PhoneBook/GetGrp27And28', ArryfildValue: null }
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((res) => {
        this.TypeNumber = res.data
        this.Contact.Mobile=[]
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i]
          var MobileList={tblGrp28:el.id,number:null,isMain:false}
          this.Contact.Mobile.push(JSON.parse(JSON.stringify(MobileList)))
          
        }
      })
    },
    SetData(Grp, Name) {
      if (Name.trim() != '' && Name != null) {
        var formData = new FormData()
        formData.append('Grp', Grp)
        formData.append('Name', Name)
        formData.append('UserGrp', this.$session.get('UserInfo').tblUserGrpId)
        var DataAxios = { Method: 'POST', Action: 'PhoneBook/SetGrp27And28', ArryfildValue: null }
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((res) => {
          this.TypeNumber = res.data
          this.Refresh = false
          this.$nextTick(() => {
            this.GetGroups()
            this.GetTypeNumber()
            this.AddModeTypeNumber = 0
            this.AddModeGroups = 0
            this.Refresh = true
            this.$toasted.success('اطلاعات با موفقیت ثبت گردید', { duration: 2000 })
          })
        })
      } else {
        this.$mySweetDefaultTost('خطا', 'نام وارد شده نباید خالی باشد', 'warning', 2000)
      }
    },
    Delete(id) {
      var formData = new FormData()
      formData.append('Id', id)
      var DataAxios = { Method: 'POST', Action: 'PhoneBook/DeleteGrp', ArryfildValue: null }
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((res) => {
        this.Refresh = false
        this.$nextTick(() => {
          this.GetGroups()
          this.GetTypeNumber()
          this.Refresh = true
        })
      })
    },
    Edit(item, Grp) {
      if (Grp == 28) {
        this.TypeNumberName = item.name
        this.AddModeTypeNumber = -1
      } else {
        this.GroupsName = item.name
        this.AddModeGroups = -1
      }
    },
    EditData(Id, Name) {
      var formData = new FormData()
      formData.append('Id', Id)
      formData.append('Name', Name)
      formData.append('UserGrp', this.$session.get('UserInfo').tblUserGrpId)
      var DataAxios = { Method: 'POST', Action: 'PhoneBook/EditData', ArryfildValue: null }
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((res) => {
        this.Refresh = false
        this.$nextTick(() => {
          this.GetGroups()
          this.GetTypeNumber()
          this.AddModeTypeNumber = 0
          this.AddModeGroups = 0
          this.Refresh = true
          this.$toasted.success('اطلاعات با موفقیت ویرایش گردید', { duration: 2000 })
        })
      })
    },
    GetResultGrp27(val) {
      this.Contact.tblGrp27 = val.id
    },
    GetResultGrp28(val) {
      this.Contact.Mobile.forEach(el => {
        if (el.tblGrp28==val.id) {
          if(el.number!="" && el.number!=null && el.number.length>3){
            el.isMain=true;
            this.Error=false;
          }
          else{
            this.$toasted.error('نوع شماره انتخابی شما خالی می باشد ، لطفا نوع دیگری انتخاب کنید', {
              duration: 2000,
            })
              this.Def28=null
              this.Error=true
          }
        }
        else{
          el.isMain=false;
        }
      });
    },
    SetContact() {
      this.Contact.tblUserGrpIdInsert=this.$session.get('UserInfo').tblUserGrpId;
      if (this.Contact.tblGrp27==null) {this.Contact.tblGrp27=1037831}
      var DataAxios = { Method: 'POST', Action: 'PhoneBook/AddPhoneBook', ArryfildValue: null }
        DataAxios.ArryfildValue = this.Contact
        this.$PostData(DataAxios).then((res) => {
          this.GetGroups()
          this.GetTypeNumber()
          this.GetAllData();
        })
    },
    GetAllData(){
      var DataAxios = { Method: 'GET', Action: 'PhoneBook/GetDataPhoneBook', ArryfildValue: null }
        this.$PostData(DataAxios).then((res) => {
          let arr=res.tblPhoneBook;
          this.voip=res.voip
          res.tblPhoneBookDetail.forEach(el => {
            el["numberType"]=res.tblCombo.find(x=>x.Id==el.tblComboGrp28CustomTypeNumber).Name
          });
          
          arr.forEach(el => {
            el["contactGroup"]=res.tblCombo.find(x=>x.Id==el.tblComboGrp27ContactGroup).Name
            el["NUM"]=res.tblPhoneBookDetail.filter(x=>x.tblPhonebookId==el.Id)
            // el["Mokhafaf"]=el.Name.slice(0,2)+""+el.Family.slice(0,1)
            el["Mokhafaf"]=el.Name!=""?el.Name.slice(0,2):el.Family.slice(0,2)

          });
          this.ListContact=arr
          this.ListContactCopy=JSON.parse(JSON.stringify(arr))
        })
    },
    Remove(row){
      this.$SweetQustion('اطمینان از  حذف مخاطب', ' از حذف مخاطب انتخابی اطمینان دارید؟', 'warning', 'اطمینان دارم', 'خیر !', row, this.Delete, this.cancel)
    },
    Delete(item){
      var formData = new FormData()
        formData.append('Id', item.Id)
        var DataAxios = { Method: 'DELETE', Action: 'PhoneBook/Delete', ArryfildValue: null }
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((res) => {
            if (res.status == 'Ok') {
              this.GetGroups()
              this.GetTypeNumber()
              this.GetAllData();
              this.$toasted.success('مخاطب با موفقیت حذف گردید', { duration: 2000 })
            }
            else{
              this.$toasted.error('خطا در حذف آیتم مورد نظر', { duration: 2000 })
            }
           
        })
    },
    Voip(number) {
      // console.log(this.Customer.voip.replace('##', number).replace('**', this.$session.get('UserInfo').voipExtension))
      console.log(this.voip.replace('##', number).replace('**', this.$session.get('UserInfo').voipExtension));
      var axios = require('axios')
      var config = {
        method: 'POST',
        url:  this.voip.replace('##', number).replace('**', this.$session.get('UserInfo').voipExtension),
        headers: {},
        data: null,
      }
      axios(config).then((response) => response.data)
    },
    CallQuestion(item,Number,numberType){
      this.$SweetQustion('اطمینان از  تماس', ' از تماس با شماره '+Number+' [ '+numberType+' ] '+' اطمینان دارید ؟', 'info', 'اطمینان دارم', 'خیر !', Number, this.Voip, this.cancel)
    },
    cancel(){
    },
    Search(e){
      this.ListContact=this.ListContactCopy.filter(x=>(x.Name+" "+x.Family).indexOf(e.target.value) >= 0 )
      // this.ListContactCopy.forEach(contact => {
      //   contact.NUM.forEach(num=>{
      //     if(num.Number.indexOf(e.target.value) >= 0){
      //       this.ListContact=contact
      //     }
      //   })
      // });
    },
    Edit(row){ 
      // var a=document.getElementsByClassName("Inputs")
      // for (let index = 0; index < a.length; index++) {
      //   const el = a[index];
      //   console.log(el.value);
      //   el.value=""
        
      // }
      this.EditMode=true
      this.Contact.Name=row.Name
      this.Contact.Family=row.Family
      this.Contact.Email=row.Email
      this.Contact.NikName=row.NikName
      this.Contact.Description=row.Description
      this.Contact.tblGrp27=row.tblComboGrp27ContactGroup
      this.Def27=row.tblComboGrp27ContactGroup
      this.$store.state.renderComponentCombo= false;
      this.$nextTick(() =>{
        this.$store.state.renderComponentCombo= true;
      })
      // this.GetTypeNumber()
      // for (let i = 0; i < row.NUM.length; i++) {
      //   if (this.Contact.Mobile.find(x=>x.tblGrp28==row.NUM[i].tblComboGrp28CustomTypeNumber)) {
      //     this.Contact.Mobile.find(x=>x.tblGrp28==row.NUM[i].tblComboGrp28CustomTypeNumber).number=row.NUM[i].Number
      //   }
      // }
      for (let i = 0; i < this.Contact.Mobile.length; i++) {
        this.Contact.Mobile[i].number=null
        if (row.NUM.find(x=>x.tblComboGrp28CustomTypeNumber==this.Contact.Mobile[i].tblGrp28)) {
          this.Contact.Mobile[i].number=row.NUM.find(x=>x.tblComboGrp28CustomTypeNumber==this.Contact.Mobile[i].tblGrp28).Number
        }
      }
    },
    CancelEditing(){
      this.EditMode=false;
      this.Contact={Name:"",Family:"",NikName:"",Description:"",Email:"", Mobile: [] }
      this.GetGroups()
      this.GetTypeNumber()
      this.GetAllData();

    }
  },
}
</script>

<style scoped>
.box {
  width: 100% !important;
  max-height: 60vh !important;
  min-height: 60vh !important;
  background: var(--sidebar-bg-color);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: var(--widget-shadow);
  overflow-y: scroll !important;
  overflow-x: clip !important;
}
.header {
  width: 100% !important;
  height: 8vh !important;
  background: #61b0ff !important;
  border-radius: 8px;
}
.Contact {
  width: 100% !important;
  height: auto !important;
  border-radius: 8px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;

  color: aliceblue;
  background: var(--sidebar-bg-color);
  transition: 0.5s;
  border-bottom: 1px solid rgba(194, 193, 193, 0.432);
}
.Contact:hover {
  transition: 0.5s;
  /* transform: scale(1.1); */
  background: #616bff71;
  box-shadow: var(--widget-shadow);
  /* border: 1px solid rgba(194, 193, 193, 0.432); */
  border: none;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
.Icon {
  width: 50px;
  height: 50px;
  border-radius: 100px;
  background: var(--logo-color);
  text-align: center;
  color: var(--sidebar-bg-color);
  line-height: 3.5rem;
  margin-top: 20% !important;
}
h4,
h5 {
  color: var(--sidebar-color-item);
}
.bg-groups {
  background: var(--sidebar-action-bg);
  border-radius: 5px;
  margin-top: 5px;
}
.fa-check-circle{
transition: 0.4s;
}
.fa-check-circle:hover{
color:rgb(162, 179, 15);
transition: 0.4s;
cursor: pointer;
}
.fa-check-circle::after{
color:rgb(82, 124, 15);
transition: 0.4s;
cursor: pointer;
}
</style>
